import React, { useEffect, useState } from "react";
import DailyCollection from "./DailyCollection";
import DaywiseCollection from "./DaywiseCollection";
import DoctorDaywiseCollection from "./DoctorDaywiseCollection";
import { FaWallet, FaCalendarDay, FaCalendarAlt, FaUserMd, FaExclamationTriangle } from "react-icons/fa";
import "./CollectionReport.css";
import axios from "axios";
import { API_BASE_URL } from "../../../../Constants/ApiEndpoints";
import DateRangePickerComponent from "../../../../CommonComponents/DateRangePickerComponent";

const CollectionReport = () => {
  const [activeTab, setActiveTab] = useState("daily");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    const pad = (n) => n.toString().padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const fetchCollectionReport = async (sDate = startDate, eDate = endDate) => {
    try {
      setLoading(true);
      setError("");
      const response = await axios.get(`${API_BASE_URL}/getCollectionReport`, {
        params: {
          fromDate: formatDate(sDate),
          toDate: formatDate(eDate)
        }
      });
      setReportData(response.data);
    } catch (err) {
      console.error("Failed to fetch collection report:", err);
      setError("Failed to fetch collection report data from server.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCollectionReport(startDate, endDate);
  }, [startDate, endDate]);

  const handleDateChange = (s, e) => {
    setStartDate(s);
    setEndDate(e);
  };

  return (
    <div className="payment-report-wrapper">
      <div className="unified-master-card">
        {/* === Master Card Header === */}
        <div className="report-master-header">
          <div className="header-title-group">
            <div className="header-icon-box">
              <FaWallet size={18} color="#2563eb" />
            </div>
            <div>
              <div className="header-subtitle">OUTPATIENT REPORTS</div>
              <h2 className="header-title">Collection Summary & Analytics</h2>
            </div>
          </div>

          <div className="header-actions-flex">
            {/* Sub-tabs Segmented Control */}
            <div className="collection-report-tabs">
              <button
                onClick={() => setActiveTab("daily")}
                className={`tab-btn ${activeTab === "daily" ? "active" : ""}`}
              >
                <FaCalendarDay size={13} />
                <span>Daily Collection</span>
              </button>
              <button
                onClick={() => setActiveTab("daywise")}
                className={`tab-btn ${activeTab === "daywise" ? "active" : ""}`}
              >
                <FaCalendarAlt size={13} />
                <span>Daywise Collection</span>
              </button>
              <button
                onClick={() => setActiveTab("doctorDaywise")}
                className={`tab-btn ${activeTab === "doctorDaywise" ? "active" : ""}`}
              >
                <FaUserMd size={13} />
                <span>Doctor Daywise Collection</span>
              </button>
            </div>

            {/* Date Range Picker */}
            <DateRangePickerComponent onDateChange={handleDateChange} />
          </div>
        </div>

        {/* Dynamic Loading / Error / View Content */}
        {loading ? (
          <div className="flex-center-card" style={{ minHeight: "300px" }}>
            <div className="loading-spinner-ring"></div>
            <p className="loading-text">Loading Collection Report Analytics...</p>
          </div>
        ) : error ? (
          <div className="flex-center-card error-card" style={{ minHeight: "300px" }}>
            <FaExclamationTriangle size={32} color="#e11d48" />
            <p className="error-text">{error}</p>
          </div>
        ) : (
          <div className="tab-content">
            {activeTab === "daily" && <DailyCollection reportData={reportData?.daily} />}
            {activeTab === "daywise" && <DaywiseCollection data={reportData?.daywise} />}
            {activeTab === "doctorDaywise" && <DoctorDaywiseCollection data={reportData?.doctorDaywise} />}
          </div>
        )}
      </div>
    </div>
  );
};

export default CollectionReport;
